import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../components/website/Footer";
import HeaderConferences from "../../components/website/HeaderConferences";
import api from "../../api/endpoints/events.js";
import Breadcrumbs from "../../components/Breadcrumbs";

function SingleGallery() {
  const [conference, setConference] = useState([]);
  const [galleryImages, setGalleryImages] = useState([]);
  const { id } = useParams();
  const [enlargedImg, setEnlargedImg] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const openEnlarged = (src, index) => {
      setEnlargedImg(src);
      setCurrentImageIndex(index);
    };

    const closeEnlarged = () => {
      setEnlargedImg(null);
      setCurrentImageIndex(null);
    };
  const switchImage = (direction) => {
    if (galleryImages.length === 0) return;

    let newIndex = currentImageIndex;

    if (direction === 'prev' && currentImageIndex > 0) {
      newIndex = currentImageIndex - 1;
    } else if (direction === 'next' && currentImageIndex < galleryImages.length - 1) {
      newIndex = currentImageIndex + 1;
    }

    if (newIndex !== currentImageIndex) {
      openEnlarged(galleryImages[newIndex].url, newIndex);
    }
  };
  const prevImage = () => {
    if (currentImageIndex > 0) {
      openEnlarged(galleryImages[currentImageIndex - 1].url, currentImageIndex - 1);
    }
  };

  const nextImage = () => {
    if (currentImageIndex < galleryImages.length - 1) {
      openEnlarged(galleryImages[currentImageIndex + 1].url, currentImageIndex + 1);
    }
  };

  const fetchData = async (page) => {
    setIsLoadingMore(true);
    try {
      const { data } = await api.get(`/Event/list/${id}?page=${page}&limit=${itemsPerPage}`);
      setGalleryImages(prevImages => [...prevImages, ...data]);
      setIsLoadingMore(false);
    } catch (error) {
      console.log('Error fetching data: ', error);
      setIsLoadingMore(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchData(1);
  }, []);

  const loadMoreImages = () => {
    setCurrentPage(currentPage + 1);
    fetchData(currentPage + 1);
  };

  const imagesToShow = galleryImages.slice(0, currentPage * itemsPerPage);

  return (
    <div>
      <HeaderConferences />
      <main>
      <section>
    <div className="container">
      <div className="breadcrumbs-about breadcrumbs-add">
        <ul>
          <li className="andThisStyle title-breadcrumbs">
            <a href="/">MAIN</a>
          </li>
          <li className="thisStyle description-breadcrumbs second-bread">
            <a href="/gallery">PAST EVENTS</a>
          </li>
          <li className="thisStyle description-breadcrumbs post-description">GALLERY</li>
        </ul>
        <Breadcrumbs />
      </div>
    </div>
  </section>
  <section>
    <div className="container">
      <div className="photogallery-events-wrapper gallery-item-wrapper">
        {imagesToShow.map((image, index) => (
            <div className="online-item gallery-item" key={index}>
              <img src={image.url} alt={`Image ${index + 1}`} />
            </div>
        ))}
      </div>
      {galleryImages.length > currentPage * itemsPerPage && (
          <div className="load-more-container">
            <button className="sponsors-button" onClick={loadMoreImages}>
              {isLoadingMore ? 'Loading...' : 'Load More'}
            </button>
          </div>
      )}
    </div>
    {enlargedImg && (
        <div className="enlarged-background">
          <div className="enlarged-overlay" onClick={closeEnlarged}>
            <div className="enlarged" onClick={closeEnlarged}>
                <img src={enlargedImg} alt="Enlarged Image" />
            </div>
          </div>
        </div>
    )}
    {currentImageIndex !== null && (
        <div className="gallery-navigation">
          <button onClick={() => switchImage('prev')}>Prev</button>
          <button onClick={() => switchImage('next')}>Next</button>
        </div>
    )}
  </section>
      </main>
      <Footer />
    </div>
  );
}

export default SingleGallery;
